module.exports = __webpack_public_path__ + "img/co2.e605d1df.svg";